import { styled } from "@material-ui/core";
import Box from "@material-ui/core/Box";

export default styled(Box)({
  fontSize: "16px",
  lineHeight: "130%",
});
